export default [
  {
    action: "manage",
    resource: "all",
    header: "Configuració",
  },
  {
    action: "manage",
    resource: "all",
    icon: "ShieldIcon",
    title: "Polítiques",
    route: "foravila-booking-policies-list",
  },
  {
    action: "manage",
    resource: "all",
    icon: "PercentIcon",
    title: "Promocions",
    route: "foravila-promotions-list",
  },
  {
    action: "manage",
    resource: "all",
    icon: "PackageIcon",
    title: "Serveis",
    route: "foravila-services-list",
  },
  {
    action: "manage",
    resource: "all",
    icon: "CompassIcon",
    title: "Normes",
    route: "foravila-rules-list",
  },
  {
    action: "manage",
    resource: "all",
    icon: "MapPinIcon",
    title: "Llocs",
    route: "foravila-places-list",
  },
];
